module.exports = __webpack_public_path__ + "static/img/智慧网易头部.87b320a5.jpg";